import { required } from 'vuelidate/lib/validators';
import VueTooltip from '@ui-common/vue-tooltip';

export default {
	name: 'personalLoanCalculatorKo2021Form',
	components: {
		VueTooltip
	},
	data() {
		return {
			model: {}
		};
	},
	props: {
		koFormData: {
			required: true
		},
		calculationResult: {
			required: true
		}
	},
	watch: {},
	validations() {
		let model = {};
		if (this.koFormData && this.koFormData.questions) {
			for (let question of this.koFormData.questions) {
				model[question.id] = { required };
				for (let answer of question.answers) {
					if (answer.questions && answer.questions.length && this.model[question.id] == answer.id) {
						for (let subQuestion of answer.questions) {
							model[subQuestion.id] = { required };
						}
					}
				}
			}
		}
		return { model };
	},
	methods: {
		sendForm() {
			if (!this.$v.$invalid) {
				this.$emit('on-form-sent', {
					calculationResult: this.calculationResult,
					formData: this.model
				});
			}
		}
	}
};
